import { colors, TextField, Typography } from '@mui/material'
import { Stack } from '@mui/system'
import React from 'react'

function LabelTxtFieldInfo({ name, title, placeholder, type, span, color, errMsg, marginTop, marginBottom, defaultValue, bgColor,
    readOnly, disabled, multiline, height, rows, width, endAdornment, step, fontSize, startAdornment, min, max, borderRadius }) {
    const labelStyle = {
        color: errMsg ? colors.red[500] : "rgba(0, 0, 0, 0.8)",
        fontWeight: 500,
        fontSize: fontSize || 12,
        // width: labelwidth ? labelwidth : 500
    }
    return (
        <Stack sx={{ width: width ? width : 500 }}>
            {/* // <Stack direction={direction} alignItems={"center"}> */}
            <Typography htmlFor={title} style={labelStyle} component={'label'} >{title}<span style={{ fontWeight: 300 }}>{span}</span></Typography>
            <TextField variant="outlined"
                InputProps={{
                    readOnly: readOnly,
                    disabled: disabled,
                    multiline: multiline,
                    rows: rows ? rows : 1,
                    endAdornment: endAdornment,
                    startAdornment: startAdornment
                }}
                sx={{
                    "& .MuiInputBase-root": {
                        height: height ? height : 45,
                        width: width ? width : 500,
                        borderRadius: borderRadius ? borderRadius : 2,
                        fontSize: fontSize || 12,
                        marginTop: marginTop || 0.4,
                        marginBottom: marginBottom || 1,
                        color: color || "rgba(0, 0, 0, 1)",
                        backgroundColor: bgColor ? bgColor : "#ffff",
                    },
                }}
                fullWidth size="small" placeholder={placeholder ? placeholder : title} name={name} type={type} defaultValue={defaultValue}
                id={title}
                error={errMsg && true}
                helperText={errMsg && errMsg}
            />
        </Stack>
    )
}

export default LabelTxtFieldInfo